import styled from "styled-components";

export const PolicyCont = styled.div`
  border-radius: 0.4rem;
  background-color: #ffffff;
  margin: ${(p) => (p.margin ? p.margin : "")};
`;
export const PolicyHeader = styled.div`
  padding: 2.3rem 3rem 2rem 3rem;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  h3 {
    font-family: 'Rubik';
    font-size: 1.8rem;
    line-height: 2.4rem;
    font-weight: 600;
    color: ${(p) => (p.theme ? p.theme.colors.black.base : "#141823")};
  }
`;
export const PolicyContent = styled.div`
  padding: 2.3rem 3rem;
  border-top: 0.1rem #e5edf6 solid;
`;
